import { average } from "./utils";

export const annotation = {
    type: 'line',
    borderColor: 'black',
    borderDash: [6, 6],
    borderDashOffset: 0,
    borderWidth: 0.5,
    label: {
      display: true,
      content: (ctx) => 'Ø ' + average(ctx).toFixed(1),
      position: 'start'
    },
    scaleID: 'y',
    value: (ctx) => average(ctx)
  };